import { createSelector } from 'reselect';
import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import { flatten } from 'lodash';
import { selectors as groupSelectors } from '../groups';
import { selectors as userSelectors } from '../users';

const options = {
  name: 'activityReportAttendances',
  baseType: 'ACTIVITY_REPORT_ATTENDANCES',
  apiEndpoint: 'activity_reports/{activity_report_id}/attendances'
};

const operations = createMetadataAPIOperations(options);
const defaultSelectors = createMetadataAPISelectors(options);
// attendances with user and group objects
const augmentedAttendances = createSelector(
  defaultSelectors.values,
  userSelectors.byId,
  groupSelectors.byId,
  (attendances, usersById, groupsById) =>
    attendances
      .map(a => {
        let user = usersById[a.user_id];
        const group = groupsById[a.group_id];
        user = {
          ...user,
          name: user ? `${user?.first_name} ${user?.last_name}` : null
        };
        return { ...a, user, group };
      })
      .filter(Boolean)
);

const selectors = {
  ...defaultSelectors,
  augmentedAttendances
};

export { operations, selectors };
const reducer = createMetadataAPIReducer(options);

const augmentedReducer = (state, action) => {
  let result = reducer(state, action);

  switch (action.type) {
    // Attendances are embedded in ActivityReports, and don't have a separate
    // endpoint. When an ActivityReport has been received, take the attendances
    // and process them in this ActivityReportAttendances reducer
    case 'FETCH_ACTIVITY_REPORTS_SUCCESS': {
      const attendances = flatten(action.payload.data.map(report => report.attendances));

      for (const attendance of attendances) {
        result = {
          ...result,
          byId: {
            ...result.byId,
            [attendance.id]: attendance
          }
        };
      }
      return result;
    }
    default: {
      return result;
    }
  }
};

export default augmentedReducer;
